import { render, staticRenderFns } from "./dealerMPerformance.vue?vue&type=template&id=2ed91421&"
import script from "./dealerMPerformance.vue?vue&type=script&lang=js&"
export * from "./dealerMPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports